import type { ProductVariantDto } from "../../../../api";
import { Text, Heading } from "../../../../components/common/typography";
import { formatDisplayName } from "../../utils/format-display-name";

type ProductDetailsGridProduct = ProductVariantDto & {
  warranty?: { name?: string | null } | null;
  warrantyType?: { name?: string | null } | null;
  countryOfOrigin?: { name?: string | null } | null;
  dealType?: { name?: string | null } | null;
};

interface ProductDetailsGridProps {
  baseProduct: ProductDetailsGridProduct;
  currentProduct: ProductDetailsGridProduct;
  selectedVariant: ProductVariantDto | null;
  availableQuantity: number;
}

export function ProductDetailsGrid({
  baseProduct,
  currentProduct,
  selectedVariant,
  availableQuantity,
}: ProductDetailsGridProps) {
  return (
    <div className="pt-6 border-t border-uiSecondary">
      <Heading variant="h3" tone="dark" className="mb-4">
        Product Details
      </Heading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {currentProduct?.defaultCode && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              SKU / Product Code
            </Text>
            <Text variant="body" tone="body">
              {currentProduct.defaultCode}
            </Text>
          </div>
        )}
        {baseProduct.type && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Type
            </Text>
            <Text variant="body" tone="body">
              {baseProduct.type}
            </Text>
          </div>
        )}
        {baseProduct.category && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Category
            </Text>
            <Text variant="body" tone="body">
              {baseProduct.category.name}
            </Text>
          </div>
        )}
        {baseProduct.brand && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Brand
            </Text>
            <Text variant="body" tone="body">
              {baseProduct.brand.name}
            </Text>
          </div>
        )}
        {baseProduct.unitOfMeasure && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Unit of Measure
            </Text>
            <Text variant="body" tone="body">
              {baseProduct.unitOfMeasure.name}
            </Text>
          </div>
        )}
        {baseProduct.warranty && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Warranty
            </Text>
            <Text variant="body" tone="body">
              {baseProduct.warranty.name}
            </Text>
          </div>
        )}
        {baseProduct.warrantyType && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Warranty Type
            </Text>
            <Text variant="body" tone="body">
              {baseProduct.warrantyType.name}
            </Text>
          </div>
        )}
        {baseProduct.countryOfOrigin && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Country of Origin
            </Text>
            <Text variant="body" tone="body">
              {baseProduct.countryOfOrigin.name}
            </Text>
          </div>
        )}
        {baseProduct.dealType && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Deal Type
            </Text>
            <Text variant="body" tone="body">
              {baseProduct.dealType.name}
            </Text>
          </div>
        )}
        {selectedVariant && selectedVariant.id !== baseProduct.id && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Selected Variant
            </Text>
            <Text variant="body" tone="body">
              {formatDisplayName(selectedVariant.displayName) ||
                selectedVariant.name ||
                selectedVariant.defaultCode ||
                "—"}
            </Text>
          </div>
        )}
        {availableQuantity !== null && availableQuantity !== undefined && (
          <div>
            <Text variant="bodyLg" tone="dark" className="mb-1">
              Available Quantity
            </Text>
            <Text variant="body" tone="body">
              {availableQuantity}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
}
